import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const AsyncBoundary = ({
  skeleton,
  fallback,
  resetKeys,
  children,
}: {
  skeleton: ReactNode;
  fallback: (retry: () => void) => ReactNode;
  resetKeys?: unknown[];
  children: ReactNode;
}) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary
        onReset={reset}
        resetKeys={resetKeys}
        fallbackRender={({ resetErrorBoundary }) =>
          fallback(resetErrorBoundary)
        }
      >
        <Suspense fallback={skeleton}>{children}</Suspense>
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);
